import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import URLSearchParams from "url-search-params";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import { ConfigProvider } from "antd/lib";
import { IntlProvider } from "react-intl";

import { AppLocale } from "../../lngProvider";
import AuthMiddleware from "./AuthMiddleware";
// import SignIn from "../SignIn";
// import SignUp from "../SignUp";
// import { setInitUrl } from "../../appRedux/actions/Auth";
import {
  onLayoutTypeChange,
  onNavStyleChange,
  setThemeType,
} from "../../appRedux/actions";
// import { ISigninModel } from "../../interfaces";
import { ThemeSetting } from "../../constants/ThemeSetting";
import CircularProgress from "../../components/CircularProgress";
import ErrorPage from "../../routes/auth/ErrorPage";
import { ChatProvider } from "../../contexts/ChatContext";
import {
  AuthenticationProvider,
  oidcLog,
  InMemoryWebStorage,
  OidcSecure,
  useReactOidc,
} from "@axa-fr/react-oidc-context";

const {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
} = ThemeSetting;

const NotFound = (props: any) => {
  if (props.match.path !== "/") return <Redirect to={"/team-work/home"} />;
  return <Fragment />;
};

const App: React.FC = (props: any) => {
  const dispatch = useDispatch();

  const { locale, navStyle, layoutType, pathname } = useSelector(
    ({ settings }: any) => settings
  );
  // const { initURL } = useSelector(({ auth }: any) => auth);

  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    let link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = "/pwa/css/style.css";
    link.className = "gx-style";
    document.body.appendChild(link);
  });

  useEffect(() => {
    // if (initURL === "") {
    //   dispatch(setInitUrl(location.pathname));
    // }
    const params = new URLSearchParams(location.search);

    if (params.has("theme")) {
      dispatch(setThemeType(params.get("theme")));
    }
    if (params.has("nav-style")) {
      dispatch(onNavStyleChange(params.get("nav-style") as string));
    }
    if (params.has("layout-type")) {
      dispatch(onLayoutTypeChange(params.get("layout-type")));
    }
    setLayoutType(layoutType);
    setNavStyle(navStyle);
  });

  const setLayoutType = (layoutType: string) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove("boxed-layout");
      document.body.classList.remove("framed-layout");
      document.body.classList.add("full-layout");
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove("full-layout");
      document.body.classList.remove("framed-layout");
      document.body.classList.add("boxed-layout");
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove("boxed-layout");
      document.body.classList.remove("full-layout");
      document.body.classList.add("framed-layout");
    }
  };

  const setNavStyle = (navStyle: any) => {
    if (
      navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER
    ) {
      document.body.classList.add("full-scroll");
      document.body.classList.add("horizontal-layout");
    } else {
      document.body.classList.remove("full-scroll");
      document.body.classList.remove("horizontal-layout");
    }
  };

  if (
    location.pathname === "/" ||
    location.pathname === "/home" ||
    location.pathname === "/team-work" ||
    location.pathname === "/index.html"
  ) {
    if (window.config.replaceInstancePageByHomePage) {
      history.push("/team-work/instance?folder=Inbox-0");
      return <Fragment />;
    }
    history.push("/team-work/home");
    return <Fragment />;
  }

  const currentAppLocale = AppLocale[locale.locale];

  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={currentAppLocale.direction}
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Router basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route path={`${match.url}`}>
              <OidcSecure>
                <ChatProvider>
                  <AuthMiddleware />
                </ChatProvider>
              </OidcSecure>
            </Route>

            <Route
              exact
              path="/error/:errorCode?"
              render={(props) => <ErrorPage {...props} />}
            />

            <Route component={NotFound} />
          </Switch>
        </Router>
      </IntlProvider>
    </ConfigProvider>
  );
};

export default memo(App);
